export const CATALOG_URL = 'catalog'
export const CATALOG_DETAIL_URL = 'catalog-detail'

export const CATALOG_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}`
export const CATALOG_BRANDS_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/brands`
export const CATALOG_BRAND_DETAIL_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/brands/:brandName`
export const CATALOG_PRODUCTS_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/products`
export const CATALOG_PRODUCT_DETAIL_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/products/:productName`
export const CATALOG_THEMES_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/themes`
export const CATALOG_THEME_DETAIL_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/themes/:themeName`
export const CATALOG_SUBTHEME_DETAIL_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/themes/:themeName/subthemes/:subThemeName`
export const CATALOG_SOURCES_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/sources`
export const CATALOG_SOURCE_DETAIL_TRANSACTION_PATH = `/project/:id/${CATALOG_URL}/sources/:sourceName`
